export const destinationFilterItems = [
  // {
  //   title: "Deals",
  //   value: "deals",
  //   items: [
  //     {
  //       value: "1",
  //       name: "Basic Deal",
  //     },
  //     {
  //       value: "2",
  //       name: "Last minute",
  //     },
  //     {
  //       value: "3",
  //       name: "Early booker",
  //     },
  //   ],
  // },

  //   {
  //     title: "Cancellation policy",
  //     value: "policy",
  //     items: [
  //       { value: "FLEXIBLE", name: "Flexible" },
  //       { value: "NON_REFUNDABLE", name: "Non-refundable" },
  //     ],
  //   },

  //   {
  //     title: "Meals",
  //     value: "meals",
  //     items: [
  //       // {
  //       //   value: "No",
  //       //   name: "No meals",
  //       // },
  //       {
  //         value: 1,
  //         name: "Breakfast",
  //       },
  //       {
  //         value: 2,
  //         name: "Lunch",
  //       },
  //       {
  //         value: 3,
  //         name: "Dinner",
  //       },
  //     ],
  //   },

  {
    title: "Property types",
    value: "propertyTypeIds",
    items: [
      { value: 201, name: "Apartment" },
      { value: 202, name: "Guest Accommodation" },
      { value: 203, name: "Hostel" },
      { value: 204, name: "Hotel" },
      { value: 205, name: "Motel" },
      { value: 206, name: "Resort" },
      { value: 207, name: "Residence" },
      { value: 208, name: "Bed and Breakfast" },
      { value: 209, name: "Ryokan" },
      { value: 210, name: "Farm Stay" },
      { value: 211, name: "Bungalow" },
      { value: 212, name: "Holiday Park" },
      { value: 213, name: "Villa" },
      { value: 214, name: "Campsite" },
      { value: 215, name: "Boat" },
      { value: 216, name: "Guest House" },
      { value: 218, name: "Inn" },
      { value: 219, name: "Aparthotel" },
      { value: 220, name: "Holiday Home" },
      { value: 221, name: "Lodge" },
      { value: 222, name: "Homestay" },
      { value: 223, name: "Country House" },
      { value: 224, name: "Luxury Tent" },
      { value: 225, name: "Capsule Hotel" },
      { value: 226, name: "Love Hotel" },
      { value: 227, name: "Riad" },
      { value: 229, name: "Condos" },
      { value: 230, name: "Cottages" },
      { value: 231, name: "Economy Hotels" },
      { value: 232, name: "Gites" },
      { value: 233, name: "Health Resorts" },
      { value: 234, name: "Cruise" },
      { value: 235, name: "Student Accommodation" },
      { value: 290, name: "Cabana" },
      { value: 291, name: "Caravan" },
      { value: 292, name: "Campground" },
      { value: 293, name: "Resort Villages" },
    ],
  },
];

// [
//   {
//     title: "Popular filters",
//     value: "popular",
//     items: [
//       "Flexible",
//       "Offer of the day",
//       "Private Bathroom",
//       "B&B",
//       "Swimming pool",
//       "4.0-5.0",
//       "Pets allowed",
//       "Fullboard",
//       "Apartments",
//     ],
//   },
// ];

// [
//     {
//         title: "Your budget",
//         value: "price",
//         items: ["$0 - $49", "$50 - $99", "$100 - $149", "$150 - $199"],
//       },

//       {
//         title: "Star rating",
//         value: "starrating",
//         items: ["1 star", "2 stars", "3 stars", "4 stars", "5 stars"],
//       },

//       {
//         title: "Review score",
//         value: "reviewscore",
//         items: ["0.0 - 0.9", "1.0 - 1.9", "2.0 - 2.9", "3.0 - 3.9", "4.0 - 5.0"],
//       },

// ]
